/*
 * <bundle-hiw-float> — floating "How it works" button (desktop only).
 * Fades in once the hero scrolls out of view; the button is a Dawn <modal-opener>,
 * so opening the modal needs no code here.
 */
if (!customElements.get('bundle-hiw-float')) {
  customElements.define(
    'bundle-hiw-float',
    class BundleHiwFloat extends HTMLElement {
      connectedCallback() {
        this.hero = document.querySelector('[data-bundle-hero]');

        // No hero to observe (or no IntersectionObserver) → just show it.
        if (!this.hero || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('is-visible', !entries[0].isIntersecting);
          },
          { rootMargin: '0px 0px -20% 0px' }
        );
        this.observer.observe(this.hero);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
